import { useRouter } from "next/router";

export const useAuthRouter = () => {
    const router = useRouter();

    const getLocale = (): string | null => router.locale ?? null;

    const getLocaleStr = (locale?: string | null): string => {
        router.locale = locale ?? router.locale;
        const _locale = locale ?? getLocale();
        return _locale ? `/${_locale}` : "";
    };

    const push = (pathWithoutLocale: string, locale?: string | null) => {
        if (window) {
            window.location.assign(`${getLocaleStr(locale)}${pathWithoutLocale}`);
        } else {
            router.push(`${getLocaleStr(locale)}${pathWithoutLocale}`).then(() => {});
        }
    };

    const replace = (pathWithoutLocale: string, locale?: string | null) => {
        if (window) {
            window.location.replace(`${getLocaleStr(locale)}${pathWithoutLocale}`);
        } else {
            router.replace(`${getLocaleStr(locale)}${pathWithoutLocale}`).then(() => {});
        }
    };

    return { push, replace };
};
